import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";

import Socket from "socket";
import Alert from "shared/components/alert";
import CardButton from "../components/Button";
import { setIsLoading } from "redux/loader/action";
import ModifyEntryModal from "../components/ModifyEntryModal";
import DeleteEntryModal from "../components/DeleteEntryModal";
import cardImage from "assets/images/challenges/card-home.jpg";
import useWindowDimensions from "shared/helpers/getWindowDimensions";
import { ReactComponent as OptionsSvg } from "assets/images/challenges/options-svg.svg";
import { dispatch } from "redux/store";

const MyEntries = () => {
  const { height } = useWindowDimensions();
  const {
    challengesReducer: { challenge_details, challenge_entries },
    gameReducer: { currentUser, mobile_app },
    paramsReducer
  } = useSelector((state) => state);

  const entries_params = _.get(
    paramsReducer,
    "paramsObj.mobile_website.challenges.entries"
  );
  const label = _.get(entries_params, "label", "My Entries");
  const text = _.get(
    entries_params,
    "text",
    "A list of all your entries for this challenge, view your progress or edit an entry."
  );
  const label_entries = _.get(entries_params, "label_entries", "All Entries");
  const unit_prefix = _.get(entries_params, "unit_prefix", "* Number of");
  const entry = _.get(entries_params, "entry", "ENTRY");
  const date = _.get(entries_params, "date", "DATE");
  const edit = _.get(entries_params, "edit", "Edit Challenge Entry");
  const hint = _.get(entries_params, "hint", "Enter Number");
  const submit = _.get(entries_params, "submit", "Submit");
  const delete_cancel = _.get(entries_params, "delete_cancel", "Cancel");

  const [modalPosition, setModalPosition] = useState({ y: null });
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState({});
  const [entryCount, setEntryCount] = useState("");
  const [editEntry, setEditEntry] = useState(false);
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    return Socket.addListener(
      "challenge-entry",
      handle_challenge_entry,
      challenge_entry_error
    );
  }, []);

  useEffect(() => {
    editEntry && setEntryCount(selectedEntry.entry.toString());
  }, [editEntry]);

  const handle_challenge_entry = (res) => {
    if (res && res.challenge_data) {
      if (res.entry_action === "Update") {
        Alert(200, "Entry updated successfully");
      } else if (res.entry_action === "Delete") {
        Alert(200, "Entry deleted successfully");
      }
      setEntryCount("");
      setEditEntry(false);
    }
  };
  const challenge_entry_error = () => {};

  useEffect(() => {
    setEntries(challenge_entries.sort((a, b) => b.entry_ts - a.entry_ts));
  }, [challenge_entries]);

  const convertedDate = (epoch_time) =>
    moment(epoch_time * 1000).format("MM/DD/YYYY");

  const handleEntryClick = (item) => {
    setSelectedEntry({
      entry: item.entry,
      entry_ts: item.entry_ts,
      time: convertedDate(item.entry_ts)
    });
    let entry_offset_top = Math.round(
      document.getElementById(item.entry_ts).getBoundingClientRect().y
    );
    entry_offset_top && setModalPosition({ y: entry_offset_top });
  };

  const resetModalPosition = () => {
    setModalPosition({ y: null });
    setSelectedEntry({});
  };

  const handleDeleteEntry = () => {
    dispatch(setIsLoading(true));
    const data = {
      action: "challenge-entry",
      challenge_id: challenge_details.challenge_id,
      entry: parseInt(selectedEntry.entry),
      entry_action: "Delete",
      entry_ts: selectedEntry.entry_ts,
      team_code: currentUser.team_code,
      user_id: currentUser.userId
      // team_code: "teamCode",
      // user_id: "1"
    };
    Socket.sendMessage(data);
    resetModalPosition();
    setDeleteModal((prev) => !prev);
  };

  const toggleDeleteEntryModal = () => {
    setDeleteModal((prev) => !prev);
  };

  const handleEditTooltip = (e) => {
    e.stopPropagation();
    setModalPosition({ y: null });
    setEditEntry(true);
  };

  const handleDeleteTooltip = (e) => {
    e.stopPropagation();
    setModalPosition({ y: null });
    setDeleteModal((prev) => !prev);
  };

  const handleEditEntrySubmit = () => {
    if (!_.isEmpty(entryCount)) {
      dispatch(setIsLoading(true));
      const data = {
        action: "challenge-entry",
        challenge_id: challenge_details.challenge_id,
        entry: parseInt(entryCount),
        entry_action: "Update",
        entry_ts: selectedEntry.entry_ts,
        team_code: currentUser.team_code,
        user_id: currentUser.userId
        // team_code: "teamCode",
        // user_id: "1"
      };
      Socket.sendMessage(data);
    } else {
      Alert(400, "Entry must not be empty");
    }
  };

  const onCancelEditEntry = () => {
    setEditEntry(false);
  };

  return (
    <div className="challenges-wrapper">
      <div className="entries-container">
        <div className="home-card">
          <img
            alt=""
            src={
              challenge_details.challenge_image !== null
                ? challenge_details.challenge_image
                : cardImage
            }
            className={`card-top-image specific ${
              editEntry ? "edit-entry" : ""
            }`}
          />
          <div
            className={`card-content entries ${editEntry ? "edit-entry" : ""}`}
          >
            <h2 className={`entries-heading ${editEntry ? "edit-entry" : ""}`}>
              {`📝 ${label}`}
            </h2>
            <p
              className={`entries-description ${editEntry ? "edit-entry" : ""}`}
            >
              {text}
            </p>

            <div className="all-entries-wrapper">
              <div className="entries-label-div">
                <span className="left-label">{label_entries}</span>
                <span className="right-label">{`${unit_prefix} ${challenge_details.unit}`}</span>
              </div>
              <div className="wrapper-entries">
                <div
                  className={`entries-header ${editEntry ? "edit-entry" : ""}`}
                >
                  <h3 className="entries-flex-1">{entry}</h3>
                  <h3 className="entries-flex-2">{date}</h3>
                  <div className="entries-flex-3" />
                </div>
                <div
                  className="list-entries"
                  style={{
                    maxHeight: `${
                      mobile_app
                        ? !editEntry
                          ? height - 326
                          : height > 700
                          ? height - 506
                          : height - 419
                        : !editEntry
                        ? height - 386
                        : height > 700
                        ? height - 566
                        : height - 479
                    }px`
                  }}
                >
                  {!_.isEmpty(entries) &&
                    entries.map((item) => (
                      <div
                        key={item.entry_ts}
                        className={`entries-header normal-row ${
                          editEntry ? "edit-entry" : ""
                        }`}
                      >
                        <h3 className="entries-flex-1 normal-row">
                          {item.entry}
                        </h3>

                        <h3 className="entries-flex-2 normal-row">
                          {convertedDate(item.entry_ts)}
                        </h3>
                        <div
                          id={item.entry_ts}
                          className="entries-flex-3 normal-row"
                          onClick={() => handleEntryClick(item)}
                        >
                          <OptionsSvg />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            {editEntry && (
              <div className="edit-entry-container">
                <h2 className={`entry-label ${editEntry ? "edit-entry" : ""}`}>
                  {edit}
                </h2>
                <input
                  type="number"
                  value={entryCount}
                  onChange={(e) => setEntryCount(e.target.value)}
                  placeholder={`${hint} (${challenge_details.unit})`}
                  className={`entry-value ${editEntry ? "edit-entry" : ""}`}
                />
                <CardButton
                  text={submit}
                  class_name={`${editEntry ? "edit-entry" : ""}`}
                  onPress={() => handleEditEntrySubmit()}
                />
                <p
                  onClick={onCancelEditEntry}
                  className={`cancel-text ${editEntry ? "edit-entry" : ""}`}
                >
                  {delete_cancel}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {modalPosition.y !== null && !_.isEmpty(selectedEntry) && (
        <ModifyEntryModal
          position={modalPosition}
          entries_params={entries_params}
          onEditEntry={handleEditTooltip}
          onCloseModal={resetModalPosition}
          onDeleteEntry={handleDeleteTooltip}
        />
      )}
      {deleteModal && !_.isEmpty(selectedEntry) && (
        <DeleteEntryModal
          selectedEntry={selectedEntry}
          entries_params={entries_params}
          onDeleteEntry={handleDeleteEntry}
          onCloseModal={toggleDeleteEntryModal}
        />
      )}
    </div>
  );
};

export default MyEntries;
